"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyngergyEMR = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class SyngergyEMR {
    constructor() { }
    /**********************************************************************************************************************
     *                     START : Synergy Software Parser
     * ********************************************************************************************************************/
    /**
     * @function parse
     * @param pastedData
     * @param event
     * @param callbackEmit
     * @summary Synergy EMR Software Parser @pastedData string break by session to session
     * @returns {callback}
     */
    parse(pastedData, event, callbackEmit) {
        try {
            const browser = (0, helper_1.detectionBrowser)();
            //**Session 1 Patient name*/
            const sessionFirst = browser == EmrConstants_1.BROWSERS.FIREFOX
                ? (0, helper_1.substrInBetween)(pastedData, EmrConstants_1.PARSER_INPUT_TYPE.PATIENT_INFO, EmrConstants_1.PARSER_INPUT_TYPE.REFERRAL.toUpperCase())
                : (0, helper_1.substrInBetween)(pastedData, "Patient info", "Language");
            //**Patient Information*/
            const patientInfo = this.gettingPatientDetails(sessionFirst);
            //**Session 3 Insurance*/
            const sessionThird = browser == EmrConstants_1.BROWSERS.CHROME
                ? (0, helper_1.substrInBetween)(pastedData, "INSURANCE NAME", "Clinicians Assigned")
                : (0, helper_1.substrInBetween)(pastedData, EmrConstants_1.PARSER_INPUT_TYPE.PATIENT_INFO, EmrConstants_1.PARSER_INPUT_TYPE.DATE_LAST_SEEN);
            const insurance = this.getInsurance(sessionThird, browser);
            //**Session 6 Emergency Contact*/
            const sessionSix = (0, helper_1.substrInBetween)(pastedData, "Emergency Contacts", "plan");
            //**Session 7 Primary Physician*/
            const sessionSeven = browser == EmrConstants_1.BROWSERS.CHROME
                ? (0, helper_1.substrInBetween)(pastedData, "Physician Info", "Last Seen by MD")
                : (0, helper_1.substrInBetween)(pastedData, EmrConstants_1.PARSER_INPUT_TYPE.RESPONSIBLE_PARTY, EmrConstants_1.PARSER_INPUT_TYPE.ADDRESS);
            //**Session 8 Pharmacy*/
            const sessionEight = (0, helper_1.substrInBetween)(pastedData, "Assign Clinician", "SN Notes");
            const physicianInfo = this.getPrimaryPhysician(sessionSix, sessionSeven, sessionEight);
            const sendCallBackData = Object.assign(Object.assign(Object.assign({}, patientInfo), insurance), physicianInfo);
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error.message : error,
                errorStack: error.stack,
            });
        }
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from Synergy
     */
    gettingPatientDetails(sessionFirst) {
        let dob;
        if (!sessionFirst) {
            return {};
        }
        const browser = (0, helper_1.detectionBrowser)();
        if (browser == EmrConstants_1.BROWSERS.FIREFOX) {
            const breaker = sessionFirst.split("\n");
            dob = breaker[breaker.length - 1].split(" ")[2];
        }
        else {
            dob = (0, helper_1.substrInBetween)(sessionFirst, "Birth Date", "Open");
        }
        if (dob) {
            dob = (0, helper_1.trim)(dob);
        }
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(browser == EmrConstants_1.BROWSERS.CHROME
                ? (0, helper_1.substrInBetween)(sessionFirst, "Sfx", "SSN")
                : sessionFirst, browser)), this.patientPhoneNumberWithAddress(sessionFirst, browser)), { dob: (0, helper_1.getDOB)(dob, true) }),
        };
    }
    /**
     * @function getInsurance
     * @param sessionThird
     * @param browser
     * @summary Getting Insurance from Synergy
     */
    getInsurance(sessionThird, browser) {
        sessionThird = (0, helper_1.trim)(sessionThird);
        if (!sessionThird) {
            return {};
        }
        let insurance;
        if (browser == EmrConstants_1.BROWSERS.FIREFOX) {
            let patientInsurance = sessionThird.split("\n").length
                ? sessionThird.split("\n")[37]
                : "";
            patientInsurance = patientInsurance ? patientInsurance.split(" ")[0] : "";
            return { insurance: patientInsurance };
        }
        const preIndexVal = (0, helper_1.substrInBetween)(sessionThird, "STATUS", "Authorizations");
        const insuranceToBreak = preIndexVal.split("\n");
        insurance = insuranceToBreak[0].split("\t");
        //Primary Insurance
        return { insurance: insurance[1] };
    }
    /**
     * @function getPrimaryPhysician
     * @param sessionSix
     * @param sessionSeven
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from Synergy
     */
    getPrimaryPhysician(sessionSix, sessionSeven, sessionEight) {
        const primaryPhy = {
            info: {
                physician: [
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 1,
                    },
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 2,
                    },
                ],
                pharmacy: this.getPharmacy(sessionEight),
                careGiver: this.getCaregiver(sessionSix),
            },
        };
        const breakPhysician = sessionSeven.split("\n");
        for (const [index, value] of breakPhysician.entries()) {
            if (breakPhysician[index - 1] == "Primary Doctor" &&
                breakPhysician[index]) {
                // @ts-ignore
                primaryPhy.info.physician[0].name = value.split(")").pop();
            }
            if (breakPhysician[index - 1] == "Other Doctor" &&
                breakPhysician[index]) {
                // @ts-ignore
                primaryPhy.info.physician[1].name = value.split(")").pop();
            }
        }
        //@Return
        return primaryPhy;
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        var _a, _b;
        let pharmCare = [];
        const pharmacyData = [
            {
                name: "",
                phoneNo: "",
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            },
            {
                name: "",
                phoneNo: "",
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 2,
            },
        ];
        //Blank data Return
        data = (0, helper_1.trim)(data);
        //Return black data
        if (!data) {
            return pharmacyData;
        }
        //convert to array
        const breakData = data.split("\t");
        for (const [index, value] of breakData.entries()) {
            if (index < 4 && breakData[index]) {
                if (index == 0) {
                    if (breakData[index].includes("Tel")) {
                        pharmCare = breakData[index].split("Tel");
                        pharmacyData[0].name = pharmCare[0];
                    }
                    else {
                        pharmCare = breakData[index + 1].split(",");
                        pharmacyData[0].name = pharmCare[0] + pharmCare[2];
                    }
                    pharmacyData[0].phoneNo = (0, helper_1.changeNumberUSFormat)((_a = pharmCare[1]) === null || _a === void 0 ? void 0 : _a.replace(/[^0-9]/g, ""));
                }
                if (index == 2) {
                    if (breakData[index].includes("Tel")) {
                        pharmCare = breakData[index].split("Tel");
                        pharmacyData[1].name = pharmCare[0];
                    }
                    else {
                        pharmCare = breakData[index + 1].split(",");
                        pharmacyData[1].name = pharmCare[0] + pharmCare[2];
                    }
                    pharmacyData[1].phoneNo = (0, helper_1.changeNumberUSFormat)((_b = pharmCare[1]) === null || _b === void 0 ? void 0 : _b.replace(/[^0-9]/g, ""));
                }
            }
        }
        //@Return
        return pharmacyData;
    }
    getCaregiver(data) {
        const caregiverData = [
            {
                name: "",
                phoneNo: "",
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            },
            {
                name: "",
                phoneNo: "",
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 2,
            },
        ];
        if (!data) {
            return caregiverData;
        }
        const breakData = (0, helper_1.substrInBetween)(data, "RELATIONSHIP", "Disaster");
        if (breakData) {
            const prevIndexData = breakData.split("\n");
            if (prevIndexData[0]) {
                const primaryCare = prevIndexData[0].split("\t");
                caregiverData[0].name = primaryCare[0];
                caregiverData[0].phoneNo = primaryCare[1];
            }
            if (prevIndexData[1]) {
                const secondaryCare = prevIndexData[1].split("\t");
                caregiverData[1].name = secondaryCare[0];
                caregiverData[1].phoneNo = secondaryCare[1];
            }
        }
        //@Return
        return caregiverData;
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param firstSession
     * @param browser
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(firstSession, browser) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
                apartmentNo: "",
            },
        };
        if (browser == EmrConstants_1.BROWSERS.FIREFOX) {
            const phoneNo = firstSession.split("\n")[1];
            info.phoneNo = phoneNo ? (0, helper_1.changeNumberUSFormat)(phoneNo) : null;
            info.phoneNo = info.phoneNo
                .replace("--", "")
                .replace("(", "")
                .replace(" ", "-")
                .replace(")", "");
            info.address.placeName = firstSession.split("\n")[2];
            info.address.apartmentNo = firstSession.split("\n")[3];
            return info;
        }
        else {
            //Numbers
            const numbers = (0, helper_1.phoneNumbers)((0, helper_1.substrInBetween)(firstSession, "Telephone", "Other Phone"));
            //Set Last number
            if (numbers && (0, helper_1.arrayLength)(numbers)) {
                const number = (0, helper_1.trim)(numbers[0].replace(/[\s-()]/g, ""));
                info.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
            }
            //set address
            const addressString = (0, helper_1.substrInBetween)(firstSession, "Address", "Patient");
            const apartmentNumber = (0, helper_1.substrInBetween)(addressString, "APT", "City");
            //Set Address
            info.address.placeName = (0, helper_1.trim)(addressString);
            info.address.apartmentNo = (0, helper_1.trim)(apartmentNumber);
            //@Return address or phoneNo
            return info;
        }
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @param browser
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionFirst, browser) {
        const name = {
            firstName: "",
            lastName: "",
        };
        if (browser == EmrConstants_1.BROWSERS.FIREFOX) {
            const breakName = sessionFirst.split("\n")[0];
            name.firstName = breakName.split(" ")[0];
            name.lastName = breakName.split(" ")[2];
            return name;
        }
        //Value trim
        if (sessionFirst) {
            sessionFirst = (0, helper_1.trim)(sessionFirst);
        }
        const breakName = sessionFirst.split("\n");
        name.firstName = (0, helper_1.trim)(breakName[1]);
        name.lastName = (0, helper_1.trim)(breakName[0]);
        //@Return name
        return name;
    }
}
exports.SyngergyEMR = SyngergyEMR;
